import { useQuery } from "@tanstack/react-query";
import taskService from "../api/taskService";

export const useTask = (taskId, args = {}) => {
  const { getTask } = taskService();

  return useQuery({
    queryKey: ["get-task", taskId],
    queryFn: async () => {
      const res = await getTask(taskId);
      return res.data;
    },
    enabled: !!taskId,
    ...args
  });
};

export const useTaskNames = (boardId) => {
  const { getAllTaskNames } = taskService();

  return useQuery({
    queryKey: ["get-all-task-names", boardId],
    queryFn: async () => {
      const res = await getAllTaskNames(boardId);
      return res.data;
    },
    enabled: !!boardId
  });
};

export const useTaskCalendarDateRange = (boardId, from, to) => {
  const { getTaskByDay } = taskService();

  return useQuery({
    queryKey: ["get-task-day", from, to],
    queryFn: async () => {
      const res = await getTaskByDay(boardId, from, to);
      return res.data;
    },
    enabled: !!from && !!to
  });
};
